import React from "react"
import { Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

import metadata from "metadata"
import { formatVersionLabel } from "helpers/version_helpers"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col>{new Date().getFullYear()} © NAT.</Col>
            <Col>
              <div className="d-flex justify-content-end align-items-center gap-3">
                <Link
                  to="/estado-servicios"
                  className="text-muted font-size-11"
                >
                  Ver estado de los servicios
                </Link>
                <span>{formatVersionLabel(metadata)}</span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
